import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import "./_shop-button.scss"

class ShopButton extends PureComponent {
  static defaultProps = {
    modifier: "",
    icon: "",
    themeClass: "",
    disabled: false,
    text: "Lorem ipsum",
    datasetBag: {},
  }

  static propTypes = {
    link: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.triggerHandler = this.triggerHandler.bind(this)
  }

  triggerHandler = (event) => {
    console.debug("triggerHandler")

    event.preventDefault()
    if (typeof this.props.triggerHandler === "function") {
      this.props.triggerHandler(event)
    }
  }

  render() {
    const { link } = this.props
    if (link) {
      return (
        <a
          href={link}
          className={`shop-button ${this.props.modifier} ${this.props.themeClass} ${this.props.disabled ? "is-disabled" : ""}`}
          {...this.props.datasetBag}
        >
          {this.props.icon && this.props.icon}
          {this.props.text && <span>{this.props.text}</span>}
        </a>
      )
    } else {
      return (
        <button
          className={`shop-button ${this.props.modifier} ${this.props.themeClass} ${this.props.disabled ? "is-disabled" : ""}`}
          onClick={this.triggerHandler}
          {...this.props.datasetBag}
        >
          {this.props.icon && this.props.icon}
          {this.props.text && <span>{this.props.text}</span>}
        </button>
      )
    }
  }
}

export default ShopButton
